// extracted by mini-css-extract-plugin
export default {"loadingSkeleton":"Gccda2b"};